module.exports = __webpack_public_path__ + "media/images/icons/man_group-a0f1c55563d925d7d97f9d4dbb695ee6.svg";